const header = document.querySelector(".shipping-picker > .header");
const expressOption = document.querySelector(".shipping-picker .option.express");

const isAtcTemplate = document.getElementById("isAtcTemplate")?.value === "true";
const isNonAtcExpressDelivery = document.getElementById("expressDelivery")?.value === "true";

const hideExpressAtcButton = document.getElementById("hideExpressAtcButton")?.value === "true";

const isExpressTemplate = (isAtcTemplate || isNonAtcExpressDelivery);
const isExpressProduct = document.getElementById("marketHandle")?.value === "ae" && document.getElementById("isExpressProduct")?.value === "true";

const swatchSelector = ".globo-swatch-list ul:not(.ul-swatches-list)";
let colorLegend = 'color';
const priceSelector = '.globo-swatch-detail-lists-price li';

function legacyLegendSelector(name) {
    return `div.ms-variant-radios fieldset[data-option-slug*="${name}" i] > legend`
}

function legendSelector(name) {
    return `.globo-swatch-list legend[data-name*="${name}" i]`;
}

// Configuration
const CONFIG = {
    maxRetries: 10,
    retryDelay: 250,
    observerTimeout: 10000, // 10 seconds max
    pollInterval: 250
};

// State tracking
let observer;
let retryCount = 0;
let isInitialized = false;

// Sands API Integration
async function processSandInventory() {
    if (!window.inventoryData) {
        try {
            const response = await fetch(`https://sands-api.clickoapps.com/api/inventory?productId=gid://shopify/Product/${window.productId}`);
            window.inventoryData = await response.json();
        } catch (error) {
            console.error('Error fetching Sands inventory:', error);
            window.inventoryData = null;
        }
    }
    return window.inventoryData;
}

function getInventoryForVariant(variantId) {
    if (!window.inventoryData || !window.inventoryData.variants) {
        return null;
    }

    const variant = window.inventoryData.variants.find(v => {
        const apiNumericId = v.variantId.split('/').pop();
        return apiNumericId == variantId;
    });

    return variant ? variant.inventory.available : null;
}

// Wait for both DOM and critical elements
function waitForElement(selector, timeout = 10000) {
    return new Promise((resolve, reject) => {
        const element = document.querySelector(selector);
        if (element) {
            resolve(element);
            return;
        }

        const startTime = Date.now();
        const checkInterval = setInterval(() => {
            const element = document.querySelector(selector);
            if (element) {
                clearInterval(checkInterval);
                resolve(element);
            } else if (Date.now() - startTime > timeout) {
                clearInterval(checkInterval);
                reject(new Error(`Element ${selector} not found within ${timeout}ms`));
            }
        }, 100);
    });
}

// Enhanced initialization with retry logic
async function initializeShippingPicker() {
    if (isInitialized) return;

    try {
        // Wait for critical elements
        await waitForElement('body');

        // Fetch Sands inventory data first
        await processSandInventory();

        // Create fallback pricing data if globo-swatch-detail-lists-price is missing
        await createFallbackPricingData();

        // Convert prices
        await convertPricesWithRetry();

        // Setup observer for swatch changes
        setupSwatchObserver();

        // Initial setup
        setTimeout(() => setupInitialSwatches(), 250);

        isInitialized = true;
        console.log('Shipping picker initialized successfully');

    } catch (error) {
        retryCount++;
        if (retryCount < CONFIG.maxRetries) {
            console.warn('Initialization failed, retrying...', error);
            setTimeout(() => initializeShippingPicker(), CONFIG.retryDelay);
        } else {
            console.error('Max retries reached, giving up');
        }
    }
}

function createFallbackPricingData() {
    if ((document.querySelector(`${legendSelector("size")} ~ ul.value`) || document.querySelector(legacyLegendSelector("size")) || document.querySelector(legacyLegendSelector("stamp"))) && !document.querySelector(priceSelector) && window.meta?.product?.variants) {
        const pricesDiv = document.createElement('div');
        pricesDiv.className = 'globo-swatch-detail-lists-price';
        pricesDiv.style.display = 'none';

        window.meta.product.variants.forEach(variant => {
            const priceLi = document.createElement('li');
            priceLi.dataset.value = variant.id;
            priceLi.dataset.priceCents = variant.price;
            pricesDiv.appendChild(priceLi);
        });

        document.body.appendChild(pricesDiv);
    }
}

// Price conversion with retry
function convertPricesWithRetry(retries = 10) {
    // Wait for DoublyGlobalCurrency to be loaded
    return new Promise((resolve, reject) => {
        function attemptConversion(attempt = 0) {
            if (typeof window.DoublyGlobalCurrency !== "undefined" && window.DoublyGlobalCurrency.convert) {
                convertPrices();
                resolve();
            } else if (attempt < retries) {
                setTimeout(() => attemptConversion(attempt + 1), CONFIG.pollInterval);
            } else {
                reject(new Error('DoublyGlobalCurrency not available'));
            }
        }
        attemptConversion();
    });
}

// Price conversion function
function convertPrices() {
    // Convert fallback prices if they exist
    if (document.querySelector(`${priceSelector}[data-price-cents]`)) {
        document.querySelectorAll(priceSelector).forEach(variantData => {
            convertPrice(variantData);
        });
    }

    // Iterate over each variant and convert the express price
    document.querySelectorAll("#airtable-data div[data-variant-id]").forEach(variantData => {
        convertPrice(variantData);
    });
}

function convertPrice(variantData) {
    let price = variantData.dataset.expressPrice ?? variantData.dataset.priceCents;
    const shopCurrency = variantData.dataset.currency ?? 'AED';

    if (price && price !== "null" && price !== "") {
        if (variantData.dataset.expressPrice) {
            price = Math.round(parseFloat(price) * 100);
        }

        const convertedPrice = DoublyGlobalCurrency.convert(
            price,
            shopCurrency,
            DoublyGlobalCurrency.currentCurrency
        );

        const formattedPrice = DoublyGlobalCurrency.formatMoney(
            convertedPrice,
            DoublyGlobalCurrency.moneyFormats[DoublyGlobalCurrency.currentCurrency][DoublyGlobalCurrency.format]
        );

        const existingSpan = variantData.querySelector("span.money");

        if (!existingSpan) {
            const span = document.createElement("span");
            span.className = "money gw-li-price";
            span.setAttribute("doubly-currency-aed", price);
            span.setAttribute("doubly-currency", shopCurrency);
            span.textContent = formattedPrice;
            variantData.appendChild(span);
        } else {
            existingSpan.setAttribute("doubly-currency-aed", price);
            existingSpan.setAttribute("doubly-currency", shopCurrency);
            existingSpan.textContent = formattedPrice;
        }
    }
}

// Enhanced observer setup
function setupSwatchObserver() {
    // Disconnect existing observer
    observer?.disconnect();

    observer = new MutationObserver((mutations) => {
        if (!document.querySelector(swatchSelector)) return;

        // Use debouncing to avoid excessive processing
        clearTimeout(observer.timeout);
        observer.timeout = setTimeout(() => {
            processSwatchUpdates();
        }, 500);
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style']
    });
}

// Debounced swatch processing
function processSwatchUpdates() {
    // Remove express shipping input if not an express product
    if (!isExpressProduct) {
        const expressInput = document.querySelector('input[name="properties[Express Shipping]"]');
        expressInput?.remove();
    }

    // Hide shipping picker header or entire row based on template
    if (!isAtcTemplate) {
        const standardLabel = document.querySelector("div.row:not(.color-express)");

        if (!isNonAtcExpressDelivery && header) {
            header.style.display = "none";
        } else if (standardLabel) {
            standardLabel.style.display = "none";
        }
    }

    // Process all swatches
    document.querySelectorAll(swatchSelector).forEach(ul => {
        const parentDiv = ul.closest('.swatch--gl');
        if (!parentDiv) return;
        ul.querySelectorAll('li').forEach(li => processSwatchItem(li, parentDiv));
    });
}

// Process individual swatch item
function processSwatchItem(li, parentDiv) {
    const label = li.querySelector("label.swatch-anchor");
    if (!label) return;

    const isColorSwatch = !!parentDiv.querySelector(`legend[data-name*="${colorLegend}" i]`);
    const isSizeSwatch = !!parentDiv.querySelector('legend[data-name*="size" i]');
    const isStampSwatch = !!parentDiv.querySelector('legend[data-name*="stamp" i]');

    // Get current selections
    const colorInput = document.querySelector(`${legendSelector(colorLegend)} ~ ul.value li input:checked`);
    const sizeInput = document.querySelector(`${legendSelector("size")} ~ ul.value li input:checked`);
    const color = colorInput ? colorInput.value : null;
    const size = sizeInput ? sizeInput.value : null;

    // Determine values for this swatch
    const swatchInput = li.querySelector("input");
    const swatchValue = swatchInput ? swatchInput.value : null;

    let currentColor = color;
    let currentSize = size;

    if (isColorSwatch && size) {
        currentColor = swatchValue;
    } else if (isSizeSwatch && color) {
        currentSize = swatchValue;
    } else {
        isColorSwatch && (currentColor = swatchValue);
        isSizeSwatch && (currentSize = swatchValue);
    }

    // Find matching variant
    const variantData = findVariantData(currentColor, currentSize, isSizeSwatch);
    updateSwatchVisuals(label, variantData, isColorSwatch, isSizeSwatch);

    // Add click listener if needed
    if (!swatchInput.hasAttribute("data-shipping-picker-injected")) {
        swatchInput.addEventListener("change", () => {
            getSwatchItemPrice(li, isColorSwatch);
            isStampSwatch && updateDetail("STAMP", label.textContent.trim());
        });
        swatchInput.setAttribute("data-shipping-picker-injected", "true");
    }
}

// Helper function to find variant data
function findVariantData(color, size, isSizeSwatch) {
    let selector = "#airtable-data div";
    if (color) {
        selector += `[data-color="${color.replace(/'/g, "\\'")}"]`;
    }
    if (isSizeSwatch && size) {
        selector += `[data-size="${size.replace(/'/g, "\\'")}"]`;
    }

    return document.querySelector(selector);
}

// Update swatch visuals
function updateSwatchVisuals(label, variantData, isColorSwatch, isSizeSwatch) {
    const variantId = variantData ? variantData.dataset.variantId : null;
    const expressPrice = variantData ? variantData.dataset.expressPrice : null;

    // Check Sand inventory (only source for express)
    const sandInventory = getInventoryForVariant(variantId);
    const hasSandInventory = sandInventory !== null && sandInventory > 0;

    const isExpressVariant = hasSandInventory && expressPrice;

    // Update dot indicator with Sand inventory consideration
    isExpressProduct && updateDotIndicator(label, isExpressVariant, isColorSwatch, variantData);

    // Add price for size swatches
    isSizeSwatch && variantId && addPriceToSizeSwatch(label, variantId);
}

function updateDetail(position, text) {
    const detail = document.querySelector(`span[data-detail="${position}"]`);
    if (!detail) return;
    detail.textContent = text;
}

// Update dot indicator
function updateDotIndicator(label, isExpressVariant, isColorSwatch, variantData) {
    // Remove existing dots
    const oldDot = label.querySelector(".dot.express, .dot.standard");
    oldDot?.remove();

    // Determine dot type
    let dotType = "standard";

    if (isColorSwatch && variantData) {
        // Check if any variants for this color have Sand inventory
        const color = variantData.dataset.color;
        const colorVariants = document.querySelectorAll(`#airtable-data div[data-color="${color.replace(/'/g, "\\'")}"]`);
        const hasExpressVariants = Array.from(colorVariants).some(variant => {
            const variantId = variant.dataset.variantId;
            const sandInv = getInventoryForVariant(variantId);
            const hasSandInv = sandInv !== null && sandInv > 0;
            return hasSandInv && variant.dataset.expressPrice;
        });

        dotType = isExpressProduct && hasExpressVariants ? "express" : "standard";
    } else if (isExpressProduct && isExpressVariant) {
        dotType = "express";
    }

    // Add new dot
    const dot = document.createElement("span");
    dot.className = `dot ${dotType}`;
    label.insertBefore(dot, label.firstChild);
}

// Add price to size swatch
function addPriceToSizeSwatch(label, variantId) {
    const priceLi = document.querySelector(`${priceSelector}[data-value="${variantId}"]`);
    const priceSpan = priceLi ? priceLi.querySelector(".gw-li-price") : null;

    if (priceSpan) {
        // Remove existing price if any
        const existingPrice = label.querySelector(".gw-li-price");
        if (existingPrice) {
            const prev = existingPrice.previousSibling;
            prev?.tagName === 'BR' && prev.remove();
            existingPrice.remove();
        }

        // Add new price
        const br = document.createElement("br");
        const clonedPrice = priceSpan.cloneNode(true);
        label.appendChild(br);
        label.appendChild(clonedPrice);
    }
}

// Initial swatch setup
function setupInitialSwatches() {
    colorLegend = document.querySelector(legendSelector("color")) ? "color" : "colour";
    if (document.querySelector(swatchSelector)) {
        // Find the first available swatch to trigger initial update
        let currentUl = document.querySelector(`${legendSelector("size")} ~ ul.value`);
        if (!currentUl) {
            currentUl = document.querySelector(`${legendSelector(colorLegend)} ~ ul.value`);
        }
        if (!currentUl) {
            currentUl = document.querySelector(".globo-swatch-list legend ~ ul.value");
        }

        const checkedInput = currentUl ? currentUl.querySelector("li input:checked") : null;
        const li = checkedInput ? checkedInput.closest("li") : currentUl?.querySelector("li");
        const swatch = currentUl ? currentUl.closest('.swatch--gl') : null;
        const label = li ? li.querySelector("label.swatch-anchor") : null;

        li && getSwatchItemPrice(li, !!swatch?.querySelector(`legend[data-name*="${colorLegend}" i]`));
        swatch?.querySelector('legend[data-name*="stamp" i]') && updateDetail("STAMP", label.textContent.trim());
    } else {
        // Fallback for non-swatch products
        setupNonSwatchProduct();
    }
}

// Get swatch item price and update UI with Sand inventory integration
function getSwatchItemPrice(li, isColorSwatch = false) {
    // Get selected color from checked inputs
    let colorInput = document.querySelector(`${legendSelector(colorLegend)} ~ ul.value li input:checked`);
    let color = colorInput ? colorInput.value : null;
    const variantDataBaseSelector = "#airtable-data div";
    // let expressVariants = 0;

    // Only update size swatches if isColorSwatch is true and size swatches exist
    if (isColorSwatch && (document.querySelector(`${legendSelector("size")} ~ ul.value`) || document.querySelector(legacyLegendSelector("size")))) {
        document.querySelectorAll(`${legendSelector("size")} ~ ul.value li`).forEach(sizeLi => {
            const label = sizeLi.querySelector("label.swatch-anchor");
            if (label) {
                const sizeInput = sizeLi.querySelector("input");
                const size = sizeInput ? sizeInput.value : null;

                // Find matching variantData by color/size
                const selector = `${variantDataBaseSelector}[data-color="${color.replace(/'/g, "\\'")}"][data-size="${size.replace(/'/g, "\\'")}"]`;
                const variantData = document.querySelector(selector);
                const variantId = variantData ? variantData.dataset.variantId : null;
                const expressPrice = variantData ? variantData.dataset.expressPrice : null;

                // Check Sand inventory (only source for express)
                const sandInventory = getInventoryForVariant(variantId);
                const hasSandInventory = sandInventory !== null && sandInventory > 0;

                const isExpressVariant = hasSandInventory && expressPrice;
                // expressVariants += isExpressVariant ? 1 : 0;

                if (isExpressProduct) {
                    // Remove existing .dot
                    const oldDot = label.querySelector(".dot.express, .dot.standard");
                    oldDot?.remove();

                    // Add .dot.express or .dot.standard
                    const dot = document.createElement("span");
                    dot.className = "dot " + (isExpressVariant ? "express" : "standard");
                    label.insertBefore(dot, label.firstChild);
                }

                // Add price for size swatch
                addPriceToSizeSwatch(label, variantId);
            }
        });
    }

    // Get selected size from checked inputs
    let sizeInput = document.querySelector(`${legendSelector("size")} ~ ul.value li input:checked`);

    // Check if the checked input's parent li has globo-out-of-stock class
    if (sizeInput && sizeInput.closest("li")?.classList.contains("globo-out-of-stock")) {
        // Find the first input that doesn't have globo-out-of-stock in parent li
        const sizeInputs = document.querySelectorAll(`${legendSelector("size")} ~ ul.value li input`);
        sizeInput = Array.from(sizeInputs).find(input => !input.closest("li")?.classList.contains("globo-out-of-stock")) || sizeInput;
        sizeInput.checked = true;
        sizeInput.dispatchEvent(new Event('change', { bubbles: true }));
        return; // Wait for the change event to trigger the price update
    }
    const size = sizeInput ? sizeInput.value : null;

    // If no color or size inputs are checked, try to find any checked input in the swatch list as a fallback
    if (!colorInput && !sizeInput) {
        colorInput = document.querySelector(`.globo-swatch-list legend ~ ul.value li input:checked`);
        color = colorInput ? colorInput.value : null;
    }

    // Find the matching variant in #airtable-data
    let selector = variantDataBaseSelector;
    if (color) {
        selector += `[data-color="${color.replace(/'/g, "\\'")}"]`;
    }
    if (size) {
        selector += `[data-size="${size.replace(/'/g, "\\'")}"]`;
    }
    const variantData = document.querySelector(selector);
    const variantId = variantData ? variantData.dataset.variantId : null;
    const expressPrice = variantData ? variantData.dataset.expressPrice : null;
    const preloved = variantData ? variantData.dataset.preloved === "true" : false;

    typeof updateProgressBar === 'function' && updateProgressBar(variantData ? variantData.dataset.condition : null);
    updateDetail("CONDITION", variantData ? variantData.dataset.condition : "Not specified");

    updateDetail("INCLUSIONS", variantData ? variantData.dataset.inclusions : "Not specified");

    // Get inventory quantity from Sands API
    const sandInventory = getInventoryForVariant(variantId);
    const inventoryQuantity = sandInventory !== null ? sandInventory : 0;

    // Still update the local inventory field for other purposes
    const inventoryQuantities = JSON.parse(document.querySelector("script[data-inventory-quantities]").textContent) || [];
    const variant = inventoryQuantities.find(v => v.id == variantId);
    const localInventoryQuantity = variant ? variant.inventory_quantity : 0;
    document.querySelector("#inventoryQuantity").value = expressPrice ? inventoryQuantity : localInventoryQuantity;

    // Check Sand inventory for express availability (only source)
    const hasSandInventory = inventoryQuantity > 0;

    const isExpressVariant = hasSandInventory && expressPrice;

    // Show or hide express badge on product images
    document.querySelectorAll(".product__modal-opener--image > .express-badge").forEach(el => {
        el.style.display = isExpressTemplate && isExpressVariant ? "flex" : "none";
        el.style.left = preloved ? "3rem" : "";
        el.style.right = preloved ? "" : "6rem";
    });
    document.querySelectorAll(".preloved-badge").forEach(el => {
        el.style.display = preloved ? "flex" : "none";
    });
    const prelovedBlock = document.querySelector(".preloved-block");
    if (prelovedBlock) {
        prelovedBlock.style.display = preloved ? "flex" : "none";
    }

    // Show or hide shipping picker header
    if (header) {
        header.style.display = isExpressVariant ? "" : "none";
    }

    const priceLi = document.querySelector(`${priceSelector}[data-value="${variantId}"]`);
    const priceSpan = priceLi ? priceLi.querySelector(".gw-li-price") : null;

    // Update main product price display
    if (priceSpan) {
        // Show and update standard price
        const standardOption = document.querySelector(".shipping-picker .option.standard");
        if (standardOption) {
            if (priceSpan && isExpressVariant) {
                standardOption.style.display = "";
                const standardPriceDiv = standardOption.querySelector(".price");
                if (standardPriceDiv) {
                    standardPriceDiv.innerHTML = priceSpan.cloneNode(true).innerHTML;
                }
            }
            else {
                standardOption.style.display = "none";
            }
        }
    }

    // Show and update express price
    if (expressOption) {
        if (isExpressVariant) {
            expressOption.style.display = "";
            const expressPriceDiv = expressOption.querySelector(".price");
            expressPriceDiv.innerHTML = variantData ? variantData.innerHTML : "";
        } else {
            // Remove Shipping Method input if it exists
            const expressInput = document.querySelector('input[name="properties[Express Shipping]"]');
            expressInput?.remove();
            expressOption.style.display = "none";
        }
    }

    // Show and update add to cart button
    const atcButton = document.querySelector(".product-form__buttons");
    if (atcButton) {
        atcButton.style.display = (
            (!isAtcTemplate && !isExpressVariant)
            || (isExpressVariant && hideExpressAtcButton))
            ? "none" : "";
    }

    // Select first visible shipping option
    const shippingOptions = document.querySelectorAll(".shipping-picker .option");
    shippingOptions.forEach(opt => {
        opt.classList.remove("selected");
    });
    setTimeout(() => {
        const shippingOption = Array.from(shippingOptions)
            .find(opt => opt.offsetParent !== null && window.getComputedStyle(opt).display !== "none");
        shippingOption?.click();
    }, 100);
}

// Fallback for non-swatch products
function setupNonSwatchProduct() {
    const variantData = document.querySelector("#airtable-data div");
    if (!variantData) return;

    const variantId = variantData.dataset.variantId;
    const preloved = variantData ? variantData.dataset.preloved === "true" : false;

    typeof updateProgressBar === 'function' && updateProgressBar(variantData ? variantData.dataset.condition : null);
    updateDetail("CONDITION", variantData ? variantData.dataset.condition : "Not specified");

    updateDetail("INCLUSIONS", variantData ? variantData.dataset.inclusions : "Not specified");

    // Check Sand inventory (only source for express)
    const sandInventory = getInventoryForVariant(variantId);
    const hasSandInventory = sandInventory !== null && sandInventory > 0;

    const isExpressVariant = hasSandInventory && variantData.innerHTML;

    if (expressOption) {
        if (isExpressVariant) {
            expressOption.style.display = "";
            const expressPriceDiv = expressOption.querySelector(".price");
            expressPriceDiv.innerHTML = variantData ? variantData.innerHTML : "";
            expressOption.click();
            document.querySelector("#inventoryQuantity").value = sandInventory;
        } else {
            // Remove Shipping Method input if it exists
            const expressInput = document.querySelector('input[name="properties[Express Shipping]"]');
            expressInput?.remove();
        }
    }

    const atcButton = document.querySelector(".product-form__buttons");
    if (atcButton) {
        atcButton.style.display = (
            (!isAtcTemplate && !isExpressVariant)
            || (isExpressVariant && hideExpressAtcButton))
            ? "none" : "";
    }

    document.querySelectorAll(".product__modal-opener--image > .express-badge").forEach(el => {
        el.style.display = isExpressProduct && isExpressVariant ? "flex" : "none";
        el.style.left = preloved ? "3rem" : "";
        el.style.right = preloved ? "" : "6rem";
    });
    document.querySelectorAll(".preloved-badge").forEach(el => {
        el.style.display = preloved ? "flex" : "none";
    });
    const prelovedBlock = document.querySelector(".preloved-block");
    if (prelovedBlock) {
        prelovedBlock.style.display = preloved ? "flex" : "none";
    }
}

// Start initialization when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeShippingPicker);
} else {
    initializeShippingPicker();
}

// Also initialize if swatches load later
// document.addEventListener('shopify:section:load', initializeShippingPicker);
// window.addEventListener('Globo.swatch.loaded', initializeShippingPicker);